import { Boxes } from 'lucide-react';

const InventoryEmpty = () => {
  return (
    <div
      className="
        flex
        min-h-[320px]
        flex-col
        items-center
        justify-center

        px-5

        text-center

        sm:px-7
      "
    >
      <span
        className="
          rounded-xl

          border
          border-primary/15

          bg-primary/10

          p-4

          text-primary

          dark:border-primary/25
          dark:bg-primary/15
        "
      >
        <Boxes className="h-8 w-8" />
      </span>

      <h3
        className="
          mt-4

          font-semibold
          text-black

          dark:text-white
        "
      >
        No hay registros de inventario para mostrar
      </h3>

      <p
        className="
          mt-1
          max-w-md

          text-sm
          text-bodydark2

          dark:text-bodydark
        "
      >
        Cambie los filtros seleccionados o agregue una
        materia prima al inventario.
      </p>
    </div>
  );
};

export default InventoryEmpty;